'use client';

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

interface WeeklyData {
  dayOfWeek: number;
  dayName: string;
  appearedCount: number;
  disappearedCount: number;
}

interface WeeklyChartProps {
  data: WeeklyData[];
}

export default function WeeklyChart({ data }: WeeklyChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="flex h-[400px] items-center justify-center text-sm text-gray-500">
        データがありません
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="dayName" />
        <YAxis />
        <Tooltip
          formatter={(value, name) => {
            const label = name === 'appearedCount' ? '新着空室' : '申込み済み';
            return [`${value}件`, label];
          }}
        />
        <Legend
          formatter={(value: string) => {
            if (value === 'appearedCount') return '新着空室';
            if (value === 'disappearedCount') return '申込み済み';
            return value;
          }}
        />
        <Bar
          dataKey="appearedCount"
          name="appearedCount"
          fill="#2563eb"
          radius={[4, 4, 0, 0]}
        />
        <Bar
          dataKey="disappearedCount"
          name="disappearedCount"
          fill="#dc2626"
          radius={[4, 4, 0, 0]}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
